// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__kerqM","badges":"styles_badges__38Je5"};